import { Controller } from "@hotwired/stimulus";

export default class ModulePrinterController extends Controller {
  static targets = ["printSection"];
  static values = {
    title: { type: String },
    moduleId: { type: String },
  }

  print() {
    const printWindow = window.open();

    printWindow.document.title = "Print";
    printWindow.document.body.style.backgroundColor = "white";

    const tailwindScript = printWindow.document.createElement("script");
    tailwindScript.src = "https://cdn.tailwindcss.com";
    printWindow.document.head.appendChild(tailwindScript);

    const printStyle = printWindow.document.createElement("style");
    printStyle.type = "text/css";
    printStyle.textContent = `
      @media print {
        body { background: white !important; color: black !important; }
        .overflow-x-auto { overflow: visible !important; }
        table { width: 100% !important; table-layout: auto !important; border-collapse: collapse; }
        th, td { white-space: normal !important; word-break: break-word; }
        table, th, td { border: 1px solid #ddd; }
        h1 { text-align: center; margin-bottom: 20px; }
      }
    `;
    printWindow.document.head.appendChild(printStyle);

    const header = printWindow.document.createElement("h1");
    header.textContent = this.titleValue;
    header.classList.add("font-bold", "text-xl", "mt-4");

    const clonedSection = this.printSectionTarget.cloneNode(true);
    this.#formatSection(clonedSection)

    tailwindScript.onload = () => {
      clonedSection.classList.remove("hidden");

      printWindow.document.body.appendChild(header);
      printWindow.document.body.appendChild(clonedSection);

      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 200);
    };
  }

  #formatSection(clonedSection) {
    if (this.moduleIdValue === "quick_assessment") {
      const cardsGrid = clonedSection.children[1];
      [...cardsGrid.children].forEach(card => {
        if (!card.classList.contains("black-border")) {
          card.classList.add("hidden");
        } else {
          card.classList.remove("h-full");
        }
      });

    }
  }
}
